var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyosu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15L8 13.25V9.75L9.75 8.725V11.75H12.25V8.725L14 9.75V13.25L11 15ZM6.75 9.5L5 8.5V6.5L6.75 5.5L8.5 6.5V8.5L6.75 9.5ZM10.5 11V5H15L14 6.5L15 8H11.5V11H10.5Z",
    fill: "#FF00D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.16115V11.75V12H9.75H12.25H12.5V11.75V9.16115L13.75 9.8933V13.1064L11 14.7106L8.25 13.1064V9.8933L9.5 9.16115ZM13.792 6.63868L14.5329 7.75H11.5H11.25V8V10.75H10.75V5.25H14.5329L13.792 6.36132L13.6995 6.5L13.792 6.63868ZM6.75 9.21206L5.25 8.35492V6.64508L6.75 5.78794L8.25 6.64508V8.35492L6.75 9.21206Z",
    stroke: "#727272",
    strokeOpacity: 0.5,
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyosu);
export default __webpack_public_path__ + "static/media/myosu.f958cff739404827aa0e1df0e5552920.svg";
export { ForwardRef as ReactComponent };